import { render } from "./FilingInfo.vue?vue&type=template&id=22ce2882&scoped=true"
import script from "./FilingInfo.vue?vue&type=script&lang=js"
export * from "./FilingInfo.vue?vue&type=script&lang=js"

import "./FilingInfo.vue?vue&type=style&index=0&id=22ce2882&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ce2882"]])